import { render, staticRenderFns } from "./UpdateAPublicExam.vue?vue&type=template&id=3f989575"
import script from "./UpdateAPublicExam.vue?vue&type=script&lang=js"
export * from "./UpdateAPublicExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports